import React from 'react'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/Menu/MenuItem'
import states from './states.json'
import get from 'lodash/get'
import MaskedInput from 'react-text-mask'

const TextMaskCustom = ({ inputRef, ...other }) =>
  <MaskedInput
    {...other}
    ref={inputRef}
    mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    placeholderChar={'\u2000'}
    showMask
  />

export default ({ handleChange, customer, errors }) =>
  <form noValidate autoComplete="off">
    <Grid container>
      <Grid item xs={12} sm={6}>
        <TextField
          error={!!errors.firstName}
          helperText={errors.firstName ? errors.firstName : null}
          id="firstName"
          label="First Name"
          value={customer.firstName}
          onChange={e => handleChange('firstName', e.target.value)}
          margin="normal"
          fullWidth
          required
          />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          error={!!errors.lastName}
          helperText={errors.lastName ? errors.lastName : null}
          id="lastName"
          label="Last Name"
          value={customer.lastName}
          onChange={e => handleChange('lastName', e.target.value)}
          margin="normal"
          fullWidth
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          error={!!get(errors, 'phoneNumbers.home')}
          helperText={get(errors, 'phoneNumbers.home') ? get(errors, 'phoneNumbers.home') : null}
          InputProps={{
            inputComponent: TextMaskCustom
          }}
          InputLabelProps={{
            shrink: true,
          }}
          id="phoneNumber"
          label="Phone Number"
          value={get(customer, 'phoneNumbers.home')}
          onChange={e => handleChange('phoneNumbers.home', e.target.value)}
          margin="normal"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          error={!!errors.email}
          helperText={errors.email ? errors.email : null}
          id="email"
          label="Email"
          value={customer.email}
          onChange={e => handleChange('email', e.target.value)}
          margin="normal"
          fullWidth
          />
      </Grid>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              id="addressLine1"
              label="Address Line 1"
              value={get(customer, 'address.line1')}
              onChange={e => handleChange('address.line1', e.target.value)}
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="addressLine2"
              label="Address Line 2"
              value={get(customer, 'address.line2')}
              onChange={e => handleChange('address.line2', e.target.value)}
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid item sm={12} md={5}>
            <TextField
              id="city"
              label="City"
              value={get(customer, 'address.city')}
              onChange={e => handleChange('address.city', e.target.value)}
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid item sm={12} md={3}>
            <TextField
              id="state"
              select
              label="State"
              value={get(customer, 'address.state', '')}
              onChange={e => handleChange('address.state', e.target.value)}
              margin="normal"
              fullWidth
            >
              {states.map(option => (
                <MenuItem key={option.abbreviation} value={option.abbreviation}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item sm={12} md={4}>
            <TextField
              id="zip"
              label="Zip Code"
              value={customer.zipCode}
              onChange={e => handleChange('address.zipCode', e.target.value)}
              margin="normal"
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </form>


// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientForm.js